import React, {Component} from "react";
import './PisaasCustomerSignUpPopUp.css';
import Authentication from "../../authentication/Authentication";
import Api from "../../api/Api";
import {toast} from 'react-toastify';

export default class PisaasCustomerSignUpPopUp extends Component {

    constructor() {
        super();
        this.state = {
            serviceName: "",
            packageId: 8,
            serviceNameIsValid: true,
            showLoadAfterCreate: false,
            showErrorMessage: false
        };

        this.authentication = new Authentication();
    }


    completeVerification(){
        this.props.toggle();
    }

    handleServiceNameInput(event, event_tag){
        const serviceName = event.target.value;

        if (serviceName.match(/^[a-z0-9]{1,22}$/)) {
            this.setState({
                serviceName: event.target.value,
                serviceNameIsValid: true
            })
        }  else {
            this.setState({
                serviceName: event.target.value,
                serviceNameIsValid: false
            })
        }

    }

    successCallback = (data) => {
        this.setState({
            showLoadAfterCreate: true
        })

        // this.props.loadAfterCreate(data);
        this.props.togglePopUp()
    }

    errorCallback = (err) => {
        console.log(err);
        toast.error("Failed to buy package", {
            position: toast.POSITION.BOTTOM_RIGHT
        });
        this.setState({
            showLoadAfterCreate: false,
            showErrorMessage: true
        })
    }

    handleSignUp = () => {
        const {serviceName, packageId} = this.state;

        const api = new Api();

        if (this.state.serviceNameIsValid) {
            api.pisaasUserSignup(this.successCallback, this.errorCallback
            , serviceName, packageId);
        }

        this.setState({
                showLoadAfterCreate: true
            }
        )
    }

    isEmpty = (str) => {
        return str.length === 0;
    }

    render() {
        return (
            <div className={"pisaas-popup-container"} data-testid="pisaas.signUp.popup">
                <div className={"box"}>
                    <button className="try-pi-btn close-button" data-testid="pisaas.signUp.button.close" onClick={() => this.props.togglePopUp()}>X</button>
                    <h3 className={"title"} data-testid="pisaas.signUp.title">Sign up to TryPi</h3>
                    <div className={"gap-top-4"}>
                        <div className={"sign-up-label"}>
                            <span className={"field-name"} data-testid="pisaas.signUp.serviceNameField">Service Name: </span>
                            <div className="tooltip" data-testid="pisaas.signUp.tooltip">
                                <i className="fa fa-info-circle" aria-hidden="true"></i>
                                <span className="tooltiptext" data-testid="pisaas.signUp.tooltip.text">Enter your chosen service name here, which will form the URL at which your TryPi instance will live. The URL will be in the format [service_name].panintelligence.cloud. Please note once you pick your service name this cannot be changed.</span>
                            </div>
                        </div>
                        <input onChange={(event) => this.handleServiceNameInput(event)} className="domain-input generic-input" data-testid="pisaas.signUp.serviceNameField.input" type="text"/>
                        {!this.state.serviceNameIsValid ? <p className={"warning-text"} data-testid="pisaas.signUp.text.warning" >Service name cannot contain special characters, spaces or be blank</p> : <></>}
                        {this.state.showErrorMessage && !this.isEmpty(this.state.serviceName) ? <p className={"warning-text"} data-testid="pisaas.signUp.text.warning">There was a problem signing up - please try again with a different service name</p> : <></>}
                    </div>
                    <div className={"signup-buttons"}>
                        <button className={"try-pi-btn gap-top-4 btn-signup-cancel"} data-testid="pisaas.signUp.button.cancel" onClick={() => this.props.togglePopUp()}>CANCEL</button>
                        {this.state.showLoadAfterCreate ? <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading"/> :
                            this.state.serviceNameIsValid && !this.isEmpty(this.state.serviceName) ? <button className={"try-pi-btn gap-top-4 btn-create"} data-testid="pisaas.signUp.button.signUp" onClick={() => {this.handleSignUp()}}>SIGN UP</button> :
                                    <button className={"try-pi-btn gap-top-4 btn-create disabled"} data-testid="pisaas.signUp.button.signUp" disabled={true}>SIGN UP</button>
                        }
                    </div>
                </div>
            </div>
        )
    }
}